module.exports = __webpack_public_path__ + "../front/img/568_bøjlestang+1hylde.47c65dcb.svg";